export default {
  styleOverrides: {
    modal: () =>
      ({
        backgroundColor: 'rgba(0,0,0,.5)',
      }),
  },
};
